import { render } from "./DailyReport.vue?vue&type=template&id=16135b6c"
import script from "./DailyReport.vue?vue&type=script&lang=ts"
export * from "./DailyReport.vue?vue&type=script&lang=ts"

import "./DailyReport.vue?vue&type=style&index=0&id=16135b6c&lang=scss"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QScrollArea,QSpinner});
